import Vue from 'vue';
import App from './App.vue';
import store from './store';

import vuetify from '@/plugins/vuetify';
import VueDOMPurifyHTML from 'vue-dompurify-html';

import VueSocketIO from 'vue-socket.io';

import { io } from 'socket.io-client';
import config from './api/config';

Vue.use(VueDOMPurifyHTML, {
    default: {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ['style', 'script']
    }
});

let localVid = '';
const uniqueId = uuidv4();

function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
}

const eventSocket = io(config.server + '/chatmanager', {
    transports: ['websocket'],
    autoConnect: false,
    upgrade: true,
    useConnectionNamespace: false,
    path: '/chatmanager/socket.io',
    query: {
        token: uniqueId
    }
});

Vue.use(
    new VueSocketIO({
        debug: false,
        connection: eventSocket
    })
);

try {
    localVid = localStorage.getItem('visitorId');

    if (localVid == null || localVid == 'null') {
        // Generate random key
        // Store it on the users computer
        localStorage.setItem('visitorId', uniqueId);
    }
} catch (error) {
    // console.log('OK');
}


Vue.config.productionTip = false;

const app = new Vue({
    store,
    vuetify,
    render: (h) => h(App)
}).$mount('#app');
